import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { ScrollElement, ScrollLink } from 'react-scroll';

// style
import './style.css';

// components


// images
import phone from '../../assets/iPhoneX.png';
import home from '../../assets/screenshot/home.jpg';

// video posters
import posterTop from '../../assets/video/poster-top.jpg';
import posterMid from '../../assets/video/poster-mid.jpg';

// custom scroll spy elements
class Element extends Component {
    render = () => {
        return (
            <section className={this.props.className} name={this.props.name}>
                {this.props.children}
            </section>
        );
    }
}
Element = ScrollElement(Element);

class Link extends Component {
    render = () => {
        return false;
    }
}
Link = ScrollLink(Link);


const LOAD_DISTANCE = window.innerHeight*1.5;
const PLAY_DISTANCE = window.innerHeight/3;

class Section extends Component {
    state = {
        ready: this.props.preload
    }

    getReady = () => {
        this.setState({
            ready: true
        })
    }

    setActive = () => {
        this.setState({
            active: true
        })
    }

    setInactive = () => {
        this.setState({
            active: false
        })
    }

    play = () => {
        if (!this.props.video || !this.video) return;
        console.log('play', this.props.name);
        this.video.play();

        ReactGA.event({
            category: 'Section',
            action: 'Viewed Item',
            label: this.props.name
        });
    }

    stop = () => {
        if (!this.props.video || !this.video) return;
        this.video.pause();
        this.video.currentTime = 0;
    }


    // lifecycle
    componentDidUpdate = (prevProps, prevState) => {
        const becameActive = !prevState.active && this.state.active;
        if (becameActive) this.play();

        // const becameInactive = prevState.active && !this.state.active;
        // else if (becameInactive) this.stop();
    }

    render = () => {
        var className = 'section';
        if (this.state.active) className += ' active';
        if (this.props.hasSlash) className += ' has-slash';

        return (
            <Element name={this.props.name} className={className}>
                {!!this.props.name &&
                    <Link
                      spy
                      to={this.props.name}
                      offset={this.state.ready ? -PLAY_DISTANCE : -LOAD_DISTANCE}
                      onSetActive={this.state.ready ? this.setActive : this.getReady}
                      onSetInactive={this.setInactive}
                    />
                }

                <div className="content-container">
                    {this.props.children}
                </div>

                <div className={'phone-container' + (this.props.hideImgForMobile ? ' hide-for-mobile' : '')}>
                    <img src={phone} alt="iPhone" className="phone" />

                    {this.props.video ?
                        <video
                          loop
                          muted
                          playsInline
                          preload={this.state.ready ? 'auto' : 'none'}
                          poster={this.props.midPoster ? posterMid : posterTop}
                          className="screenshot"
                          ref={(el) => { this.video = el; }}
                         >
                            {!!this.props.webm && <source src={this.props.webm} type="video/webm" /> }
                            {!!this.props.mp4  && <source src={this.props.mp4}  type="video/mp4" /> }
                        </video>
                    :
                        <img src={this.props.image || home} alt="Burst Home" className="screenshot" />
                    }
                </div>
            </Element>
        );
    }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/index.js